import { YStack, XStack, Text } from "tamagui";
import { useNavigate } from "react-router-dom";
import { RiTimeLine } from "react-icons/ri";
import toast from "react-hot-toast";
import { colors } from "@styles/colors";
import { useOrder } from "@utils/store/cart/useOrder";
import DeliverTimeCard from "./components/DeliverTimeCard";
import { GasCard, GasLabel, SkinBottomBar, isGasSkinV2 } from "./skin";
import { track } from "@lib/tracker";
import { shouldShowPaymentStep } from "@utils/func/billingCustomerType";

/**
 * 下訂步驟 Step 1：先選配送時間（預約／立即），按「下一步」進付款方式（電子付款開啟時）或結帳確認頁。
 * 對齊設計稿「先選時間 → 結帳」流程。
 */
const GasShopDeliveryTime = () => {
  const navigate = useNavigate();
  const { deliveryTime, allowElectronicPay, isMonthlyCustomer, isMeteredCustomer } = useOrder();
  const skinV2 = isGasSkinV2();

  const isValid =
    deliveryTime.type === "immediate" ||
    (deliveryTime.type === "scheduled" && !!deliveryTime.date && !!deliveryTime.slotId);

  const handleNext = () => {
    if (!isValid) {
      toast.error("請選擇配送時間", { id: "delivery-time-required" });
      return;
    }
    track("funnel_step", { step: "deliveryTime", delivery_mode: deliveryTime.type });
    // 一般客戶且瓦斯行開啟電子付款 → 先選付款方式；
    // 月結／走表客戶依計費方式結算，金額未定，跳過該步直接進確認訂單頁
    navigate(
      shouldShowPaymentStep({ allowElectronicPay, isMonthlyCustomer, isMeteredCustomer })
        ? "/gasShop/payment"
        : "/gasShop/cart",
    );
  };

  const ctaLabel = deliveryTime.type === "immediate" ? "下一步 · 立即配送" : isValid ? "下一步" : "請選擇日期與時段";

  return (
    <YStack gap={15} flex={1}>
      <GasCard>
        <GasLabel label="配送時間" icon={<RiTimeLine color={colors.primary} />} />
        <YStack mt="$3">
          <DeliverTimeCard />
        </YStack>
      </GasCard>

      {skinV2 ? (
        <SkinBottomBar
          secondaryLabel="返回選購"
          onSecondary={() => navigate("/gasShop/products")}
          primaryLabel={ctaLabel}
          onPrimary={handleNext}
          primaryDisabled={!isValid}
        />
      ) : (
        <YStack
          backgroundColor={colors.bg}
          pt={8}
          pb={8}
          style={{ position: "sticky", bottom: "0", width: "100%", zIndex: 100 }}>
          <XStack
            className={isValid ? "gasshop-btn-gradient" : ""}
            backgroundColor={isValid ? undefined : colors.gray100}
            borderRadius={12}
            p={15}
            alignItems="center"
            justifyContent="center"
            onPress={handleNext}
            opacity={isValid ? 1 : 0.6}
            cursor={isValid ? "pointer" : "default"}>
            <Text color={isValid ? "white" : colors.gray} fontSize={16} fontWeight="bold">
              {ctaLabel}
            </Text>
          </XStack>
        </YStack>
      )}
    </YStack>
  );
};

export default GasShopDeliveryTime;
